module.exports = __webpack_public_path__ + "static/media/search-solid.dcb8f2b7.svg";